import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "errorpage",
  class: "w-full h-full"
}
const _hoisted_2 = { class: "flex flex-col h-full justify-center items-center" }
const _hoisted_3 = { class: "mt-10" }

import router from '@/router';

export default /*#__PURE__*/_defineComponent({
  __name: 'Logout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t("logout.headline")), 1),
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("logout.subline")), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/login')))
        }, _toDisplayString(_ctx.$t("logout.buttonText")), 1)
      ])
    ])
  ]))
}
}

})